import api from "./axios";

// LIST
export const getParties = async (
    page = 1,
    limit = 500,
    search = ""
)=>{


    const response = await api.get(
        "/parties",
        {
            params:{
                page,
                limit,
                search
            }
        }
    );


    return response.data;

};

// CREATE

export const createParty=(data)=>{
    return api.post("/parties",data);
};

// SINGLE

export const getParty=(id)=>{
    return api.get(`/parties/${id}`);
};

// UPDATE

export const updateParty=(id,data)=>{
    return api.patch(`/parties/${id}`, data);
};

// DELETE

export const deleteParty=(id)=>{
    return api.delete(`/parties/${id}`);
};